import { Navigate, useLocation } from 'react-router-dom'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'

import { getOauthClient, setToken } from 'utils'

class LoginCallbackInner extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  }

  state = {}

  componentDidMount() {
    const oauth = getOauthClient()
    const { location } = this.props
    const fullPath = `${location.pathname}${location.search}${location.hash}`

    oauth.token.getToken(fullPath).then(({ accessToken }) => {
      setToken(accessToken)
      this.setState({ redirect: true })
    })
  }

  render() {
    if (this.state.redirect) {
      const search = queryString.parse(this.props.location.search)
      return <Navigate to={search.redirectTo || '/'} replace />
    }

    return <div>Você tem que estar logado para acessar esta página</div>
  }
}

const LoginCallback = () => {
  const location = useLocation()
  return <LoginCallbackInner location={location} />
}

export default LoginCallback
